/**
 * The following scripts get applied on the frontend of your site.
 */

jQuery(document).ready(function () {

    jQuery('.media-compare').each(function () {
        const handle = jQuery(this).find('.slider-handle');
        const mediaOne = jQuery(this).find('.media-one');
        
        handle.on('input', function () {
            mediaOne.css('clip-path', `polygon(0 0, ${jQuery(this).val()}% 0, ${jQuery(this).val()}% 100%, 0% 100%)`);
        });
    });

});